
/* BLACK BARON — self-contained WebGL chrome extrusion; no libraries or network needed.
   The original logo alpha contour forms the actual front, back, and metal side walls. */
(function(){
'use strict';
const contours=window.BB_LOGO_CONTOURS;
if(!contours || !contours.length)return;
const VS=`
attribute vec3 aPosition;
attribute vec3 aNormal;
attribute vec2 aUV;
uniform float uYaw;
uniform float uPitch;
uniform float uAspect;
uniform float uCamera;
varying vec3 vNormal;
varying vec3 vPos;
varying vec2 vUV;
void main(){
  float cx=cos(uPitch), sx=sin(uPitch), cy=cos(uYaw), sy=sin(uYaw);
  vec3 a=vec3(aPosition.x,aPosition.y*cx-aPosition.z*sx,aPosition.y*sx+aPosition.z*cx);
  vec3 p=vec3(a.x*cy+a.z*sy,a.y,-a.x*sy+a.z*cy);
  vec3 n=vec3(aNormal.x,aNormal.y*cx-aNormal.z*sx,aNormal.y*sx+aNormal.z*cx);
  vNormal=vec3(n.x*cy+n.z*sy,n.y,-n.x*sy+n.z*cy);
  vPos=p;
  vUV=aUV;
  float depth=uCamera-p.z;
  float f=2.80;
  gl_Position=vec4(p.x*f/uAspect,p.y*f,depth*1.002-0.2002,depth);
}`;
const FS=`
precision highp float;
varying vec3 vNormal;
varying vec3 vPos;
varying vec2 vUV;
uniform sampler2D uLogo;
uniform float uSurface;
void main(){
  vec3 n=normalize(vNormal);
  vec3 v=normalize(vec3(-vPos.xy*.09,1.0));
  float facing=abs(dot(n,v));
  vec3 refl=reflect(-v,n);
  float lightA=pow(max(dot(refl,normalize(vec3(-.67,.47,.77))),0.0),35.0);
  float lightB=pow(max(dot(refl,normalize(vec3(.71,-.24,.67))),0.0),69.0);
  float soft=clamp(.49+.35*sin(refl.x*7.8+refl.y*4.6)+.25*sin(refl.y*16.0-refl.z*7.0),0.0,1.0);
  vec3 dark=vec3(.028,.095,.21);
  vec3 mid=vec3(.22,.43,.65);
  vec3 silver=vec3(.93,.96,1.0);
  vec3 metal=mix(dark,mid,clamp(soft*1.18,0.0,1.0));
  metal=mix(metal,silver,clamp(pow(soft,3.0)*.87+lightA*1.15+lightB*1.10,0.0,1.0));
  if(uSurface<.5){
    vec4 tex=texture2D(uLogo,vUV);
    if(tex.a<.095)discard;
    float bright=.73+.27*max(dot(n,normalize(vec3(-.24,.49,1.0))),0.0);
    float sheen=pow(max(dot(refl,normalize(vec3(-.42,.35,.84))),0.0),24.0);
    vec3 face=tex.rgb*bright+vec3(.23,.28,.38)*sheen;
    face=mix(face,vec3(.88,.94,1.),clamp(lightB*.32,0.0,.24));
    gl_FragColor=vec4(min(face,vec3(1.)),tex.a);
  }else{
    metal*=.78+.23*pow(1.0-facing,2.0);
    gl_FragColor=vec4(metal,1.0);
  }
}`;
function compile(gl,type,src){
 const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);
 if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(s)||'shader error');return s;
}
function program(gl){
 const p=gl.createProgram();gl.attachShader(p,compile(gl,gl.VERTEX_SHADER,VS));gl.attachShader(p,compile(gl,gl.FRAGMENT_SHADER,FS));gl.linkProgram(p);
 if(!gl.getProgramParameter(p,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(p)||'link error');return p;
}
function buildWalls(){
 const verts=[];const worldW=5.65;const ratio=613/1349;
 const worldPt=p=>[(p[0]-.5)*worldW,(.5-p[1])*worldW*ratio];
 const add=(p,n)=>{verts.push(...p,...n,0,0);};
 const rings=[[-.38,-.012],[-.29,.006],[.29,.006],[.38,-.012]];
 for(const c of contours){
   if(c.length<3)continue;
   let area=0;
   for(let i=0;i<c.length;i++){
     const a=worldPt(c[i]),b=worldPt(c[(i+1)%c.length]);area+=a[0]*b[1]-b[0]*a[1];
   }
   const dir=area>0?1:-1;
   for(let i=0;i<c.length;i++){
     const a=worldPt(c[i]),b=worldPt(c[(i+1)%c.length]);
     const dx=b[0]-a[0],dy=b[1]-a[1],len=Math.hypot(dx,dy);
     if(len<1.e-5)continue;
     const nx=dy/len*dir,ny=-dx/len*dir;
     for(let k=0;k<rings.length-1;k++){
       const [za,pa]=rings[k],[zb,pb]=rings[k+1];
       const A=[a[0]+nx*pa,a[1]+ny*pa,za], B=[b[0]+nx*pa,b[1]+ny*pa,za];
       const C=[a[0]+nx*pb,a[1]+ny*pb,zb], D=[b[0]+nx*pb,b[1]+ny*pb,zb];
       const bevel=(pa-pb)*3.5;
       const nz=(k===0?-bevel:k===2?bevel:0);
       const s=Math.hypot(nx,ny,nz),n=[nx/s,ny/s,nz/s];
       add(A,n);add(B,n);add(D,n);add(A,n);add(D,n);add(C,n);
     }
   }
 }
 return new Float32Array(verts);
}
function faceBuffer(z,sign){
 const w=5.65,h=w*613/1349;
 const l=-w*.5,r=w*.5,t=h*.5,b=-h*.5;
 const points=[[l,t,z,0,0,sign,0,1],[l,b,z,0,0,sign,0,0],[r,b,z,0,0,sign,1,0],
 [l,t,z,0,0,sign,0,1],[r,b,z,0,0,sign,1,0],[r,t,z,0,0,sign,1,1]];
 return new Float32Array(points.flat());
}
function create(canvas,textureUrl){
 if(!canvas || !window.WebGLRenderingContext)return null;
 const gl=canvas.getContext('webgl',{alpha:true,antialias:true,depth:true,premultipliedAlpha:false,preserveDrawingBuffer:false,failIfMajorPerformanceCaveat:false});
 if(!gl)return null;
 try{
   const prog=program(gl);
   gl.useProgram(prog);
   const loc={p:gl.getAttribLocation(prog,'aPosition'),n:gl.getAttribLocation(prog,'aNormal'),uv:gl.getAttribLocation(prog,'aUV'),
     yaw:gl.getUniformLocation(prog,'uYaw'),pitch:gl.getUniformLocation(prog,'uPitch'),asp:gl.getUniformLocation(prog,'uAspect'),
     surface:gl.getUniformLocation(prog,'uSurface'),camera:gl.getUniformLocation(prog,'uCamera')};
   gl.uniform1f(loc.camera,5.05); gl.uniform1i(gl.getUniformLocation(prog,'uLogo'),0);
   const buffers={};
   for(const [name,data] of [['walls',buildWalls()],['front',faceBuffer(.385,1)],['back',faceBuffer(-.385,-1)]]){
     const b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,data,gl.STATIC_DRAW);
     buffers[name]={buffer:b,count:data.length/8};
   }
   let texReady=false;
   const tex=gl.createTexture();gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
   gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([224,236,246,0]));
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
   // Chrome/Safari reject cross-origin images as WebGL textures without CORS.
   // For Shopify, use the *original* data URI shipped in bb-logo-texture-embedded.js.
   const img=new Image();
   img.crossOrigin='anonymous';
   img.decoding='async';
   let textureFailed=false;
   img.onload=()=>{
     try {
       gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
       gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
       gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,img);
       texReady=true;
     } catch(e) {
       textureFailed=true;
       console.warn('BLACK BARON: chrome face texture unavailable; retaining solid CSS logo.', e);
     }
   };
   img.onerror=()=>{textureFailed=true;console.warn('BLACK BARON: chrome face texture could not load.');};
   img.src=textureUrl;
   const bind=name=>{
     const rec=buffers[name];gl.bindBuffer(gl.ARRAY_BUFFER,rec.buffer);
     gl.enableVertexAttribArray(loc.p);gl.vertexAttribPointer(loc.p,3,gl.FLOAT,false,32,0);
     gl.enableVertexAttribArray(loc.n);gl.vertexAttribPointer(loc.n,3,gl.FLOAT,false,32,12);
     gl.enableVertexAttribArray(loc.uv);gl.vertexAttribPointer(loc.uv,2,gl.FLOAT,false,32,24);
     gl.drawArrays(gl.TRIANGLES,0,rec.count);
   };
   let cw=0,ch=0;
   const render=(pitch,yaw)=>{
     if(gl.isContextLost())return;
     const rect=canvas.getBoundingClientRect();
     if(rect.width<1||rect.height<1)return;
     const dpr=Math.min(window.devicePixelRatio||1,1.6),width=Math.round(rect.width*dpr),height=Math.round(rect.height*dpr);
     if(cw!==width||ch!==height){canvas.width=cw=width;canvas.height=ch=height;gl.viewport(0,0,width,height);}
     gl.clearColor(0,0,0,0);gl.clearDepth(1);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
     gl.useProgram(prog);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);
     gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);
     gl.uniform1f(loc.yaw,yaw*Math.PI/180);gl.uniform1f(loc.pitch,pitch*Math.PI/180);
     gl.uniform1f(loc.asp,width/height);
     gl.uniform1f(loc.surface,1);bind('walls');
     if(texReady){gl.uniform1f(loc.surface,0);bind('front');bind('back');}
   };
   return {render,ready:()=>texReady,failed:()=>textureFailed};
 }catch(e){console.warn('BLACK BARON logo renderer: fallback',e);return null;}
}
window.createBlackBaronLogo3D=create;
})();

